import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import { copyToClipboard } from '@/utils/helper';
import { CopyIconNew } from '@/assets/icons';
import { sendClickEvent } from '@/utils/AnalyticsUtils';
import { Toast, Tooltip } from '@/widgets';

import styles from './CopyText.module.scss';

const CopyText = ({
	template,
	text,
	eventName,
	textStyle,
	iconStyle,
	className,
	onCopy,
}) => {
	function textCopyHandler(text, eventName) {
		sendClickEvent({ name: eventName, value: text });
		copyToClipboard(text, {
			onSuccess: () =>
				Toast.success(`Text copied successfully.`, {
					description: text,
				}),
			onFailed: () => Toast.error('Unable to copy. Please try again.'),
			showToast: false,
		});

		if (onCopy) {
			onCopy();
		}
	}

	function renderTemplate() {
		if (template) {
			return template;
		}

		return (
			<>
				<div className={cx(styles.text, textStyle)}>{text}</div>
				<Tooltip title="Copy text!">
					<div>
						<CopyIconNew
							className={cx(styles.icon, iconStyle)}
							onClick={() => {
								textCopyHandler(text, eventName);
							}}
						/>
					</div>
				</Tooltip>
			</>
		);
	}

	return (
		<div className={cx(styles.copyTextWrapper, className)}>
			{renderTemplate()}
		</div>
	);
};

CopyText.propTypes = {
	template: PropTypes.string,
	text: PropTypes.string,
	eventName: PropTypes.string,
	textStyle: PropTypes.string,
	iconStyle: PropTypes.string,
	className: PropTypes.string,
	onCopy: PropTypes.func,
};
CopyText.defaultProps = {
	template: '',
	text: '',
	eventName: '',
	textStyle: '',
	iconStyle: '',
	className: '',
	onCopy: () => {},
};

export default CopyText;
